const applyModalStyles = () => {
  const style = document.createElement('style');
  style.innerHTML = `
    .site-header {
      z-index: -1 !important;
    }
  `;
  document.head.appendChild(style);
};

const resetModalStyles = () => {
  const fallback = document.createElement('style');
  fallback.innerHTML = `.site-header { z-index: 102 !important; }`;
  document.head.appendChild(fallback);
};

export const modalStyleSwitcher = (value: boolean) => {
  if (value) {
    applyModalStyles();
  } else {
    resetModalStyles();
  }
};
